module.exports = __webpack_public_path__ + "img/bottom_icon_my_t.6eb7d5b7.svg";